import React from 'react'
import { useNewTranslation } from 'hooks/index'
import Text from 'particles/Text'
import { ROUTES } from 'components/Root'
import Icon from 'components/Icon/Icon'
import { ErrorPageContainer } from './style'
import { useWindowSize } from 'hooks'
import { RectangleLinkButton } from 'particles/Button/RectangleButton'

interface DeniedPageProps {
    title: string
    subtitle: string
}

export const DeniedPage: React.FC<DeniedPageProps> = ({ title, subtitle }) => {
    const [newT] = useNewTranslation()
    const windowSize = useWindowSize()

    return (
        <ErrorPageContainer>
            <div className={'body'}>
                <Icon.NotFoundIcon width={Number(windowSize) > 768 ? '356px' : '301px'} />
                <Text scale="H4" color="primary" className="title">
                    {title}
                </Text>
                <Text scale="bodyM500" color="secondary" className="subtitle">
                    {subtitle}
                </Text>
                <RectangleLinkButton
                    form="filled"
                    size="l"
                    label={newT('button.viewAllSubmission', 'View All Submissions')}
                    to={ROUTES.SubmissionsDashboard}
                />
            </div>
        </ErrorPageContainer>
    )
}

export const PermissionDenied: React.FC = () => {
    const [newT] = useNewTranslation()

    return (
        <DeniedPage title={newT('emptyState.cantViewPageTitle')} subtitle={newT('emptyState.cantViewPageSubtitle')} />
    )
}

export const PageNotFound: React.FC = () => {
    const [newT] = useNewTranslation()

    return (
        <DeniedPage title={newT('emptyState.cantFindPageTitle')} subtitle={newT('emptyState.cantFindPageSubtitle')} />
    )
}
